const mutations = {
  USER_LOGGED_IN (state, data) {
    state.isAuthenticated = true
    state.user = data
    state.accounts = data.accounts
    delete state.user.accounts
  },
  SHOW_LOWER_BID_ERROR (state, data) {
    state.displayLowerMinBid = data.displayLowerMinBid
  },
  SET_ACTIVE_ACCOUNT (state, account) {
    state.activeAccount = account
  },
  UPDATE_ACTIVE_ACCOUNT (state, account) {
    state.activeAccount = {
      ...state.activeAccount,
      ...account
    }
  },
  UPDATE_ACCOUNTS (state, account) {
    state.accounts = state.accounts.map((item) => {
      if (item.id === account.id) {
        return account
      }
      return item
    })
  },
  LOGOUT (state) {
    state.isAuthenticated = false
    state.user = null
    state.accounts = null
  },
  USER_UPDATED (state, updatedUser) {
    state.user = updatedUser
  },
  USER_COMPLETED_TOUR (state, isCompleted) {
    if (state.user && 'information' in state.user) {
      state.user['information']['slider_seen'] = isCompleted
    }
  },
  USER_BONUS_SEEN (state, isCompleted) {
    if (state.user && 'information' in state.user) {
      state.user['information']['bonus_seen'] = isCompleted
    }
  },
  SHOW_NOTIFICATION_BAR (state, data) {
    state.barNotifications = data.barNotifications
  }
}

export default mutations
